// utils/origenVenta.js — ESPEJO FRONTEND de backend/utils/origenVenta.js (diag-origen-clientes-pos,
// 19-oct-2026). Definición ÚNICA del origen Web/POS de una venta, compartida por Clientes, Pedidos y
// Resumen. Las dos implementaciones (back y front) son IDÉNTICAS; cada lado tiene su suite. Sin
// runtime compartido (patrón colTime). `normalizeSalesChannel` (orderUtils) delega en `canalDetallado`.

// Pedido COMPLETO ({ meta_data, created_via }) o SLIM del perfil ({ meta_pos, meta_canal, created_via }).
function metasDe(p) {
  if (!p) return [];
  if (Array.isArray(p.meta_data)) return p.meta_data;
  return [].concat(p.meta_pos || [], p.meta_canal || []);
}
function metaValor(p, key) { const m = metasDe(p).find((x) => x && x.key === key); return m ? m.value : undefined; }

// POS = meta origen=POS o _created_via_dashboard (mismo disparador que el Pedidos/Resumen de siempre).
export function esVentaPos(p) {
  return metasDe(p).some((m) => m && ((m.key === 'origen' && m.value === 'POS') || m.key === '_created_via_dashboard'));
}

// Canal DETALLADO de un pedido (lo que muestran Pedidos y Resumen). Reproduce 1:1 el normalizeSalesChannel viejo.
export function canalDetallado(p) {
  if (esVentaPos(p)) {
    const canal = metaValor(p, 'canal_venta');
    if (canal) return { key: canal, label: canal, variant: canal === 'WhatsApp' ? 'pos-wa' : canal === 'Feria' ? 'pos-feria' : 'pos' };
    return { key: 'Sin canal', label: 'Sin canal', variant: 'pos' };
  }
  if (p && (p.created_via === 'checkout' || p.created_via === 'rest-api')) return { key: 'Web', label: 'Web', variant: 'web' };
  if (p && p.created_via === 'admin') return { key: 'Admin', label: 'Admin', variant: 'admin' };
  return { key: 'Sin canal', label: 'Sin canal', variant: 'unknown' };
}

// Etiqueta legible del ORIGEN POR CLIENTE para el badge, a partir del `origen` (value) y los
// `origen_counts` que manda el backend. Un solo canal → su nombre; varios → «Web + POS» (orden fijo).
const ORDEN = ['Web', 'POS', 'Admin', 'Sin canal'];
const NOMBRE_VALUE = { web: 'Web', pos: 'POS', admin: 'Admin', sin_canal: 'Sin canal' };
export function etiquetaOrigenCliente(value, counts) {
  if (value === 'mixto' && counts) {
    const presentes = ORDEN.filter((k) => counts[k]);
    if (presentes.length) return presentes.join(' + ');
  }
  return NOMBRE_VALUE[value] || null; // null = desconocido (el badge muestra «—»)
}
